const CODE_TYPES = ['DOT', 'MC', 'SCAC', 'UUID']

export const saveCarrierDataToLocalStorage = (res: any) => {
  if (!res) return
  const masterCarrier = res.masterCarrier

  if (masterCarrier?.carrierInfo?.carrierId) {
    localStorage.setItem('carrierId', String(masterCarrier.carrierInfo.carrierId))
  }
  if (masterCarrier?.carrierInfo?.carrierName) {
    localStorage.setItem('carrierName', masterCarrier.carrierInfo.carrierName)
  }

  const codes: { codeType: string; codeValue: string }[] = masterCarrier?.carrierInfo?.carrierCodes ?? []
  const primaryCode = codes.find((c) => CODE_TYPES.includes(c.codeType))
  if (primaryCode) {
    localStorage.setItem('carrierCodeType', primaryCode.codeType)
    localStorage.setItem('carrierCodeValue', primaryCode.codeValue)
  }
  const policyCode = codes.find(
    (c) => c.codeType === 'POLICY_ID' || c.codeType === 'POLICY ID'
  )
  localStorage.setItem('carrierPolicyId', policyCode?.codeValue ?? '')
}
